import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_PATHS } from '../config/api-paths';
import { LenderChannel } from '../tokens/lender-risk-rules.token';
import { LenderPricingApi, PricingConfig } from '../tokens/lender-pricing.token';

/**
 * REST-only implementation of {@link LenderPricingApi} (EM-699 / F2 — EM-707).
 *
 * Calls the story-B3 backend (EM-702) `/api/v1/pricing/**` surface through the
 * gateway. Per-grade rate bounds are enforced server-side; the slider UI enforces
 * the same bounds client-side. REST-only per Rules 07/10; rides the Keycloak bearer.
 */
@Injectable()
export class LenderPricingRestService implements LenderPricingApi {
  private readonly http = inject(HttpClient);

  getPricing(channel: LenderChannel): Observable<PricingConfig> {
    return this.http.get<PricingConfig>(`${API_PATHS.PRICING}/${channel}`);
  }

  savePricing(channel: LenderChannel, config: PricingConfig): Observable<PricingConfig> {
    return this.http.put<PricingConfig>(`${API_PATHS.PRICING}/${channel}`, config);
  }

  copyFromGeneral(channel: LenderChannel): Observable<PricingConfig> {
    return this.http.post<PricingConfig>(`${API_PATHS.PRICING}/${channel}/copy-from-general`, {});
  }
}
